import React, { useEffect, useState } from 'react';
import { MenuItem, Stack, TextField, Typography } from '@mui/material';

import { Pagination } from 'components/Pagination';
import { PAGE_SIZE_OPTIONS, usePageSize } from 'hook/usePageSize';

export const usePaging = () => {
  const [page, setPage] = useState(1);
  const [order, setOrder] = useState('desc');
  const [pageSize, setPageSize] = usePageSize();

  const changeOrder = (value) => {
    setOrder(value);
    setPage(1);
  };

  return { page, order, pageSize, setPage, setPageSize, changeOrder };
};

export const PagedList = ({ paging, total, sortLabel, children }) => {
  const { page, order, pageSize, setPage, setPageSize, changeOrder } = paging;
  const lastPage = Math.max(1, Math.ceil(total / pageSize));

  useEffect(() => {
    if (page > lastPage) setPage(lastPage);
  }, [page, lastPage, setPage]);

  return (
    <Stack gap={2} flex={1}>
      <Stack direction="row" justifyContent="flex-end" alignItems="center" gap={1}>
        <Typography variant="caption" color="text.secondary">
          {sortLabel}
        </Typography>
        <TextField
          select
          size="small"
          value={order}
          onChange={(event) => changeOrder(event.target.value)}
          inputProps={{ 'aria-label': 'Sort order' }}
          sx={{ minWidth: 150 }}
        >
          <MenuItem value="desc">Newest first</MenuItem>
          <MenuItem value="asc">Oldest first</MenuItem>
        </TextField>
      </Stack>

      {children}

      {total > PAGE_SIZE_OPTIONS[0] && (
        <Stack alignItems="center" pt={1} mt="auto">
          <Pagination
            page={page}
            handlePageChange={(_, value) => setPage(value)}
            itemCount={total}
            itemsPerPage={pageSize}
            onItemsPerPageChange={setPageSize}
          />
        </Stack>
      )}
    </Stack>
  );
};
